import { ChangeDetectorRef, Component, OnInit, ViewRef } from '@angular/core';
import { RestorationDbService } from 'app/core/o2c/admin/_services/restoration-db.service';

@Component({
  standalone: false,
  selector: 'kt-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  restorationDate: string;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private restorationDbService: RestorationDbService
) { }

  ngOnInit(): void {
  }

  getRestorationDate(): void {        
    this.restorationDbService.getRestorationDate()
      .subscribe(
        (response: string) => {
          this.restorationDate = response;
          this.updateDOM();
        },
        (error) => {
          console.error('Error fetching restoration date:', error);
      }
    );
  }

  /**
     * Checks if theres a new change in the dom to be forced
     * @author Castor Transformación Digital - Alvaro Felipe Garcia Mendez
     * @since 2020-03-20
     */
  public updateDOM(): void {
    if (this.changeDetectorRef && !(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
    }
}

}
